export enum FeatureToggle {
  IppAiAgent = 'rt_ipp_ai_agent',
  IppCookieConsentManagement = 'rt_ipp_cookie_consent_management',
  IppCookieDetectionEnabled = 'rt_ipp_cookie_detection_enabled',
}
